import { render, staticRenderFns } from "./payresult.vue?vue&type=template&id=0c90d339&scoped=true&"
import script from "./payresult.vue?vue&type=script&lang=js&"
export * from "./payresult.vue?vue&type=script&lang=js&"
import style0 from "./payresult.vue?vue&type=style&index=0&id=0c90d339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c90d339",
  null
  
)

export default component.exports